import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

export const DIRECT_CONTACT_LISTING_TYPE = 'direct-contact-service';

export const DIRECT_CONTACT_FIELD_KEYS = [
  'contactPhone',
  'contactEmail',
  'contactTelegram',
  'contactWhatsApp',
  'contactWebsite',
  'contactOther',
];

const DIRECT_CONTACT_LABEL_IDS = {
  contactPhone: 'ListingPage.directContactPhone',
  contactEmail: 'ListingPage.directContactEmail',
  contactTelegram: 'ListingPage.directContactTelegram',
  contactWhatsApp: 'ListingPage.directContactWhatsApp',
  contactWebsite: 'ListingPage.directContactWebsite',
  contactOther: 'ListingPage.directContactOther',
};

export const isDirectContactListing = publicData =>
  publicData?.listingType === DIRECT_CONTACT_LISTING_TYPE;

const getTrimmedText = value => {
  if (value == null) {
    return null;
  }

  const textValue = typeof value === 'string' ? value : `${value}`;
  const trimmedValue = textValue.trim();
  return trimmedValue ? trimmedValue : null;
};

export const getDirectContactFields = (publicData, intl) => {
  if (!isDirectContactListing(publicData)) {
    return [];
  }

  return DIRECT_CONTACT_FIELD_KEYS.reduce((fields, key) => {
    const value = getTrimmedText(publicData?.[key]);
    return value
      ? fields.concat({
          key,
          label: intl.formatMessage({ id: DIRECT_CONTACT_LABEL_IDS[key] }),
          value,
        })
      : fields;
  }, []);
};

const DirectContactDetailsMaybe = props => {
  const { publicData, intl } = props;

  if (!isDirectContactListing(publicData)) {
    return null;
  }

  const directContactFields = getDirectContactFields(publicData, intl);
  if (directContactFields.length === 0) {
    return null;
  }

  return (
    <section className={css.directContactSection}>
      <Heading as="h2" rootClassName={css.sectionSubheading}>
        <FormattedMessage id="ListingPage.directContactTitle" />
      </Heading>

      <ul className={css.directContactList}>
        {directContactFields.map(field => (
          <li key={field.key} className={css.directContactRow}>
            <span className={css.directContactLabel}>{field.label}:</span>
            <span className={css.directContactValue}>{field.value}</span>
          </li>
        ))}
      </ul>

      <p className={css.directContactDisclaimer}>
        <FormattedMessage id="ListingPage.directContactDisclaimerLine1" />
        <br />
        <FormattedMessage id="ListingPage.directContactDisclaimerLine2" />
      </p>
    </section>
  );
};

export default DirectContactDetailsMaybe;
